require('./brokerThreeContainerSummary.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const classNames = require('classnames');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

class BrokerThreeContainerSummary extends React.Component {

    constructor(props) {
        super(props);
    }

    createContainer(list) {
        const size = list.length;
        let content = [];

        list.forEach((item, index) => {
            if (index < size - 1) {
                content.push(this.createInformativeListItem(index, item[0], item[1], item[2], false, item[3]));
            }
            else {
                content.push(this.createInformativeListItem(index, item[0], item[1], item[2], true, item[3]));
            }
        })

        return (
            <OKInformativeList>
                {content}
            </OKInformativeList>
        );
    }

    createInformativeListItem(index, title, value, value2, lastCell, children) {
        const { itemClass } = this.props;

        const classNameItem = classNames({
            'broker-three-container-summary__title': !lastCell,
            'broker-three-container-summary__title--last': lastCell,
        });

        return (
            <OKInformativeListItem
                key={index}
                title={title}
                columns={"1"}
                isUppercaseTitle={true}
                className={classNameItem}
            >
                <span className={`${itemClass} broker-three-container-summary__container-info broker-three-container-summary__container-info--name`}>
                    {value}{value2}
                </span>
                {children}
            </OKInformativeListItem>
        );
    }

    render() {
        const { data, columns, extraClass } = this.props;

        let threeColumn;
        const hasThreeColumn = data.rightContainer.length > 0 ? true : false;
        const classNameLastColumn = classNames({
            'broker-three-container-summary__titles-container-middle': hasThreeColumn,
            'broker-three-container-summary__titles-container-right': !hasThreeColumn,
        });

        if (hasThreeColumn) {
            threeColumn = (
                <div className={`col-lg-${columns}`}>
                    <div className={`${extraClass} broker-three-container-summary__titles-container-right`}>
                        {this.createContainer(data.rightContainer)}
                    </div>
                </div>
            );
        }

        return (
            <section className="broker-three-container-summary__info-section row">
                <div className={`col-lg-${columns}`}>
                    <div className={`${extraClass} broker-three-container-summary__titles-container-left`}>
                        {this.createContainer(data.leftContainer)}
                    </div>
                </div>

                <div className={`col-lg-${columns}`}>
                    <div className={`${extraClass} ${classNameLastColumn}`}>
                        {this.createContainer(data.middleContainer)}
                    </div>
                </div>
                {threeColumn}
            </section>

        );
    }

}

BrokerThreeContainerSummary.propTypes = {
    data: PropTypes.object.isRequired,
    extraClass: PropTypes.string,
    itemClass: PropTypes.string,
    columns: PropTypes.string
};

BrokerThreeContainerSummary.defaultProps = {
    columns: "4"
};

module.exports = BrokerThreeContainerSummary;
